 
import React from 'react';

const BurgerMenu: React.FC<object> = () => {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 4H23" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
        <path d="M1 12H23" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
        <path d="M1 20H23" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
    </svg>;
};

export default BurgerMenu;